import { IMediaDTO } from "media/model"
import { mediaRPO } from "media/repository"

export const searchMediaByName = (filter: string): Promise<IMediaDTO[]> => mediaRPO.getMediaByName(filter)
